import { stringify } from './utils';

export const urls = {
  external: {
    rovoHome: 'https://rovo.atlassian.com/',
    aboutRovo:
      'https://www.atlassian.com/blog/bitbucket/rovo-chat-bitbucket-beta',
    support: 'https://support.atlassian.com/bitbucket-cloud/',
    suggestOrRequireChecksBeforeMerge:
      'https://confluence.atlassian.com/x/EhMQMw',
    accessKeys: 'https://confluence.atlassian.com/x/I4CNEQ',
    generateSshKey: 'https://confluence.atlassian.com/x/X4FmKw',
    statusPage: 'https://bitbucket.status.atlassian.com/',
    troubleshootSsh: 'https://confluence.atlassian.com/x/64Y1E',
    repositoryAccessToUsersAndGroupsInfo:
      'https://confluence.atlassian.com/x/9A0zDQ',
    mergeChecks:
      'https://support.atlassian.com/bitbucket-cloud/docs/suggest-or-require-checks-before-a-merge/',
  },
  ui: {
    createBranch: (
      issueKey?: string,
      issueType?: string,
      issueSummary?: string
    ): string => {
      const query = stringify({
        issueKey,
        issueType,
        issueSummary,
      });
      return `/branch/create${query}`;
    },
  },
};
